Vue.filter('isRadioOrderGroup', function (propertyGroup) {
  if (!propertyGroup || !propertyGroup.properties || !propertyGroup.properties[0] || !propertyGroup.properties[0]) {
    return false;
  }

  const orderPropertyGroupingType = propertyGroup.group ? propertyGroup.group.orderPropertyGroupingType : null;
  const valueType = propertyGroup.properties[0].valueType;
  if (valueType === 'empty') {
    if (!orderPropertyGroupingType || orderPropertyGroupingType === 'none' || orderPropertyGroupingType === 'multi') {
      return false;
    }

    return true;
  }
  return false;
});
